
@if (anticipatedTime) {
  <span
    >{{ anticipatedTime | elapsedTime: '[d] days + [h]h:[m]m' }}
  </span>
}
@if (showBlueIcon) {
  <i
    class=" pi pi-info-circle font-normal mr-2 icon-color"
    pTooltip="AD Time Complete"
  ></i>
}
@if (timeTakenForReviewAdjudication !== 0) {
  <span
    >{{ timeTakenForReviewAdjudication | elapsedTime: '[d] days + [h]h:[m]m' }}
  </span>
}
